module.exports = __webpack_public_path__ + "img/paint-slice_04.d2548f23.jpg";